import type { StaffImportsApi } from "@lafayette/api-client";
import { createContext, type ReactNode, useContext } from "react";

// What the import pages need from outside: the typed API client (it also sends the file to the signed
// storage URL) and the clock. The admin app supplies the real ones (`admin-runtime.ts`); a test
// supplies a fake API.

export type ImportsRuntime = Readonly<{
  api: StaffImportsApi;
  now: () => Date;
  /** How often the review page reads the progress of a job that validates or processes. Default 3000 ms. */
  progressPollMs?: number;
}>;

const RuntimeContext = createContext<ImportsRuntime | null>(null);

export function ImportsRuntimeProvider({
  value,
  children,
}: Readonly<{ value: ImportsRuntime; children: ReactNode }>) {
  return <RuntimeContext.Provider value={value}>{children}</RuntimeContext.Provider>;
}

export function useImportsRuntime(): ImportsRuntime {
  const runtime = useContext(RuntimeContext);
  if (runtime === null) throw new Error("The import pages need an ImportsRuntimeProvider.");
  return runtime;
}
